define('common/module/realtime/Serum.RealtimeUpdater',[
  'common/module/realtime/Serum.SseEventEmitter',
  'common/js/lib/Serum.Pubsub',
  'jquery'
], function(EventEmitter, Pubsub, $) {
  'use strict';

  var Updater = function() {
    var emitter = new EventEmitter();
    var targets = {};

    function setupTargetRemoval($target, id) {
      Pubsub.subscribe(Pubsub.topics.CONTENT_RELOAD, function($container) {
        if (!$target.closest($container).length) {
          return;
        }

        removeTarget(id, $target);
      });
    }

    function addTarget($target) {

      var id = $target.attr('data-id');
      var version = $target.attr('data-version');

      if (!$target.is(':visible')) {
        return;
      }

      targets[id] = targets[id] || $();
      targets[id].push($target);

      setupTargetRemoval($target, id);

      emitter.subscribeTo(id, version);
    }

    function removeTarget(id, $target) {
      targets[id] = targets[id].filter(function(target) {
        return target !== $target.get(0);
      });
    }

    function initialize() {

      Pubsub.subscribe('REALTIME_CONTENT_UPDATE', function(data) {

        targets[data.id].each(function() {
          $(this).trigger('realtimeupdate', data);
        });
      });
    }

    initialize();

    return {
      addTarget : addTarget,
      removeTarget : removeTarget
    };
  };

  Updater.get = (function() {
    var updater;

    return function() {
      if (!updater) {
        updater = new Updater();
      }

      return updater;
    };

  })();


  return Updater;
});
